export default {
  edit: "export:edit",
  create: "export:create",
  delete: "export:delete",
  view: "export:view",
};
